import axios from "axios";
import { config } from "../utils/conf";
import { requestHeaders } from "../utils/http";

export const DEFAULT_LIMIT = 10;

export const fetchBulkOrdersTotal = (customerId, filter, accessToken) => {
  return {
    type: "FETCH_BULK_ORDER_LOG_TOTAL",
    payload: axios.get(`${config.orderApiUrl}/v1/orders/uploads`, {
      headers: requestHeaders(accessToken),
      params: {
        customerId: customerId,
      },
    }),
  };
};

export const fetchBulkOrders = (
  customerId,
  filter,
  accessToken,
  offset = 0,
  limit = DEFAULT_LIMIT,
) => {
  return {
    type: "FETCH_BULK_ORDER_LOG",
    payload: axios.get(`${config.orderApiUrl}/v1/orders/uploads`, {
      headers: requestHeaders(accessToken),
      params: {
        customerId: customerId,
        limit: limit,
        offset: offset,
      },
    }),
  };
};

export const resetState = () => {
  return {
    type: "RESET_STATE",
  };
};
